'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isArray = function isArray(v) {
  return Object.prototype.toString.call(v) === '[object Array]';
};
var isString = function isString(v) {
  return typeof v === 'string';
};
var isFunction = function isFunction(v) {
  return typeof v === 'function';
};

exports.isArray = isArray;
exports.isString = isString;
exports.isFunction = isFunction;


//////////////////
// WEBPACK FOOTER
// /app/~/get-js/lib/util.js
// module id = 3343
// module chunks = 38